import { daysOld, daysOldIcon, daysUntil, daysUntilDue, formatDate } from './days';
import { toPercentage, inWords, toCurrency, tel } from './numbers';

export default {
    install(Vue) {
        Vue.filter('daysOld', daysOld);
        Vue.filter('daysOldIcon', daysOldIcon);
        Vue.filter('daysUntil', daysUntil);
        Vue.filter('daysUntilDue', daysUntilDue);
        Vue.filter('formatDate', formatDate);
        Vue.filter('toCurrency', toCurrency);
        Vue.filter('toPercentage', toPercentage);
        Vue.filter('inWords', inWords);
        Vue.filter('tel', tel);
    }
}